module.exports = __webpack_public_path__ + "static/ai-3-sq-3a947c67e4b1b15327bb32dedd835c86.png";